import { UntypedFormControl } from '@angular/forms';

export class DigitalAsset {
  filename: UntypedFormControl;
  filePath: UntypedFormControl;
  width: UntypedFormControl;
  height: UntypedFormControl;
  uom: UntypedFormControl;
  resolution: UntypedFormControl;
  colorMode: UntypedFormControl;
  description: UntypedFormControl;
  background: UntypedFormControl;
  orientationView: UntypedFormControl;
  effectiveDate: UntypedFormControl;
  expirationDate: UntypedFormControl;
  country: UntypedFormControl;
  language: UntypedFormControl;
  additionalInfo: UntypedFormControl;
  file_type: UntypedFormControl;
}
